import React, { useState } from "react";
import "./css/Login.css"; // Reusing matrix background

export default function PlanPayment() {
  const upiId = "aareek898@ptyes"; // Your UPI ID
  const name = "Load Checker";     // Your name / business
  const amount = "2500";
  const [screenshot, setScreenshot] = useState(null);

  // Generate UPI & QR URL
const upiUrl = `upi://pay?pa=dfdf@paytm&pn=Aditya &am=499&cu=INR`;
const qrCodeUrl = `https://quickchart.io/qr?size=300&text=${encodeURIComponent(upiUrl)}`;
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setScreenshot(URL.createObjectURL(file));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Payment screenshot submitted!");
    // TODO: Send to backend
  };

  return (
    <div className="login-container">
      <div className="matrix-bg"></div>

      <div className="login-box" style={{ maxWidth: "400px", width: "90%" }}>
        <h2>Activate Premium – ₹{amount}</h2>

        <p>Scan this QR code or use UPI ID below to pay ₹{amount}.</p>

        {/* QR Code */}
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <img
            src={qrCodeUrl}
            alt="UPI QR Code"
            style={{ width: "280px", height: "280px", border: "2px solid #00ff00" }}
            onError={() => alert("QR Code failed to load.")}
          />
        </div>

        <p style={{ fontWeight: "bold", color: "#00ff00", textAlign: "center" }}>
          UPI ID: {upiId}
        </p>

        {/* Screenshot Upload */}
        <form onSubmit={handleSubmit}>
          <label style={{ marginTop: "20px", display: "block" }}>
            Upload Payment Screenshot:
          </label>
          <input type="file" accept="image/*" onChange={handleFileChange} required />

          {screenshot && (
            <div style={{ marginTop: "10px" }}>
              <img
                src={screenshot}
                alt="Uploaded Screenshot"
                style={{ width: "100%", borderRadius: "8px" }}
              />
            </div>
          )}

          <button
            type="submit"
            style={{
              marginTop: "20px",
              backgroundColor: "#222",
              color: "#00ff00",
              padding: "10px",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            Submit Payment
          </button>
        </form>
      </div>
    </div>
  );
}
